<template>
  <div id="container">
  </div>
</template>

<script>
import { TMap } from "utils/TMap";
export default {
  name: "map",
  data () {
    return {
      markerLayer: null, // MultiMarker
      key: 'P6BBZ-L25RQ-YGQ5W-GF6XH-CHGEH-FAFMW'
    }
  },
  methods: {
    // 地图初始化函数，本例取名为init，开发者可根据实际情况定义
    // initMap () {
    //   // 定义地图中心点坐标
    //   var center = new window.TMap.LatLng(22.557854, 113.985979)
    //   // 定义map变量，调用 TMap.Map() 构造函数创建地图
    //   var map = new window.TMap.Map(document.getElementById('cont'), {
    //     center: center, // 设置地图中心点坐标
    //     zoom: 17.2, // 设置地图缩放级别
    //     pitch: 43.5, // 设置俯仰角
    //     rotation: 45, // 设置地图旋转角度
    //   })
    //   //创建并初始化MultiMarker
    //   this.markerLayer = new window.TMap.MultiMarker({
    //     map: this.map,  //指定地图容器
    //     //样式定义
    //     styles: {
    //       //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
    //       "myStyle": new window.TMap.MarkerStyle({
    //         "width": 35,  // 点标记样式宽度（像素）
    //         "height": 35, // 点标记样式高度（像素）
    //         "src": 'map.png',  //图片路径 这里不设置，就会使用默认的样式
    //         //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
    //         "anchor": { x: 16, y: 32 }
    //       })
    //     },
    //     //点标记数据数组
    //     geometries: [{
    //       "id": "1",   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
    //       "styleId": 'myStyle',  //指定样式id
    //       "position": center,  //点标记坐标位置
    //     }]
    //   })
    //   console.log(map)
    //   console.log(window)
    // }
    _getLocation () {
      // getLocation(this.orgId).then(res=>{
      //   let data = res.data.data.librarys
      let data = [
        {
          lat: this.coordinate.lat,
          lng: this.coordinate.lng,
          libraryName: this.agencyName
        }
      ]
      this._TMap(data)
      // })
    },
    _TMap (data) {
      TMap(this.key).then(qq => {
        var center = new qq.maps.LatLng(this.coordinate.lat, this.coordinate.lng);
        var map = new qq.maps.Map(document.getElementById("container"), {
          // 地图的中心地理坐标
          center: center,
          // 初始化地图缩放级别
          zoom: 17, // 设置地图缩放级别
          pitch: 43.5, // 设置俯仰角
          rotation: 45 // 设置地图旋转角度
        });
        // 添加提示窗
        var infoWin = new qq.maps.InfoWindow({
          map: map
        });
        // 添加标记
        for (let i = 0; i < data.length; i++) {
          var marker = new qq.maps.Marker({
            position: new qq.maps.LatLng(data[i].lat, data[i].lng),
            map: map
          })
          marker.libraryName = data[i].libraryName
          qq.maps.event.addListener(marker, 'click', function () {
            infoWin.open();
            infoWin.setContent('<div style="font-size:14px;text-align:center;white-space:' +
              'nowrap;margin:10px;"> ' + marker.libraryName + ' </div>');
            // 提示窗位置
            infoWin.setPosition(new qq.maps.LatLng(data[i].lat, data[i].lng));
          })
        }
      });
    },
    // 将百度地图经纬度转换为腾讯/高德地图经纬度
    bMapTransQQMap (lng, lat) {
      let x_pi = 3.14159265358979324 * 3000.0 / 180.0;
      let x = lng - 0.0065;
      let y = lat - 0.006;
      let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
      let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
      let lngs = z * Math.cos(theta);
      let lats = z * Math.sin(theta);

      return {
        lng: lngs,
        lat: lats
      }
    }
  },
  mounted () {
    this.coordinate = this.bMapTransQQMap(this.$route.query.longitude, this.$route.query.latitude);
    this.agencyName = this.$route.query.agencyName
    // this.initMap()
    this._getLocation()
  }
}
</script>

<style scoped>
  #container{
    width: 100%;
    height: 100%;
  }
</style>
